import { RouteLocationNormalizedLoaded } from "vue-router"
import { ApiPageOneAbsoluteUrlResponse } from "~/types/server/api/page"

export const usePageOneApi = () => {
  /**
   * `/api/page/one/${absoluteUrl}` を実行・取得する、場合によってリダイレクト処理を行う
   * @param absoluteUrl ${absoluteUrl} に指定される値
   * @param route useRoute で取得したルート情報（pass_query やリダイレクト時に full_path を参照する）
   * @returns
   */
  const fetchWithHandleRedirect = async (absoluteUrl: string, route: RouteLocationNormalizedLoaded) => {
    const nuxtApp = useNuxtApp()
    const { data } = await useAsyncData("pageFetch", async () => {
      return await $fetch<ApiPageOneAbsoluteUrlResponse>(`/api/page/one/${absoluteUrl}`, {
        params: {
          pass_query: route.query.pass_query?.toString(),
        },
        method: "GET",
      })
    })

    const response = data.value
    // Queryの結果がない場合は404
    if (response?.status !== 200) {
      throw createError({
        statusCode: 404,
        statusMessage: `Page Not Found absoluteUrl:${absoluteUrl}`,
        fatal: process.client,
      })
    }

    if (response.data.page.redirect_on && response.data.page.redirect_url) {
      const currentPath = route.path
      const redirectPath = response.data.page.redirect_url
        .replace(/^https?:\/\/[^/]+/, "") // ドメイン除去
        .split("?")[0] // クエリパラメータ除去
      if (redirectPath !== currentPath) {
        const fullPath = route.fullPath
        const splitNum = fullPath.indexOf("?") + 1
        const queryString = splitNum > 0 ? fullPath.substring(splitNum - 1) : ""

        // awaitを使わず、明示的にreturnする
        await nuxtApp.runWithContext(() =>
          navigateTo(response.data.page.redirect_url + queryString, {
            external: true,
            replace: true,
            redirectCode: 301,
          }),
        )
      }
    }

    return response.data
  }

  return { fetchWithHandleRedirect }
}
